import Vue from "vue";
import Vuex from "vuex";
import authModule from "./modules/auth/index.js";
import drawerModule from "./modules/drawer/index.js";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth: authModule,
    drawer: drawerModule,
  },
});
